module.exports = __webpack_public_path__ + "Roboto-Black.ec4c9962ba54eb91787a.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Black.ttf
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Black.ttf
// module chunks = styles